import { render, staticRenderFns } from "./ImageNew.vue?vue&type=template&id=522ca7ae"
import script from "./ImageNew.vue?vue&type=script&lang=js"
export * from "./ImageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports